var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.42 14.116a1.25 1.25 0 0 0 0 1.768l2.97 2.971a1.25 1.25 0 0 0 1.768 0l2.97-2.971a1.25 1.25 0 0 0 0-1.768l-2.97-2.971a1.25 1.25 0 0 0-1.768 0l-2.97 2.971Zm-16.549 0a1.25 1.25 0 0 0 0 1.768l2.972 2.971a1.25 1.25 0 0 0 1.767 0l2.971-2.971a1.25 1.25 0 0 0 0-1.768l-2.97-2.971a1.25 1.25 0 0 0-1.768 0L2.87 14.116Zm8.274 8.274a1.25 1.25 0 0 0 0 1.769l2.971 2.97a1.25 1.25 0 0 0 1.768 0l2.971-2.97a1.25 1.25 0 0 0 0-1.769l-2.971-2.97a1.25 1.25 0 0 0-1.768 0l-2.97 2.97Zm0-16.548a1.25 1.25 0 0 0 0 1.768l2.971 2.97a1.25 1.25 0 0 0 1.768 0l2.971-2.97a1.25 1.25 0 0 0 0-1.768l-2.971-2.97a1.25 1.25 0 0 0-1.768 0l-2.97 2.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/component.95148a00f0202421e58b09ff21f7ce72.svg";
export { ForwardRef as ReactComponent };